module.exports = __webpack_public_path__ + "media/A3.042053a7.mp3";